var map = {
	"./email.png": "4834",
	"./facebook.png": "70c5",
	"./linkedin.png": "500c",
	"./pinterest.png": "fb5d",
	"./twitter.png": "5f8d",
	"./whatsapp.png": "afe3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f441";